import { GetNewsListRequest } from '@finance-lab/utils/types'
import ApiBase from './Api'

const NEWS_API_PATHS = {
    NEWS: '/news',
}

class NewsApi extends ApiBase {
    async findAll() {
        const response = await this._getRequest<GetNewsListRequest>(NEWS_API_PATHS.NEWS)

        return response
    }
}

export default NewsApi
